module.exports = __webpack_public_path__ + "static/media/imran-avatar.d6aee442.jpg";